<template>
  <div class="shopify_wrapper">
      <div class="header_warpper">
          <div class="right">
              <div class="shopifylogo"></div>
             <div class="desxc">{{$t('other.a406')}}-{{$t('other.a407')}}</div>
          </div>
          <div class="left">
              
          </div>
          
      </div>
      <div class="center">
          <h1>Shopee We Analy tool Privacy Policy</h1>
          <h6 style="margin:20px 0">Last Edited on 31 March, 2022</h6>

        <p>Your privacy is important to us. This privacy policy has been compiled to better serve those who are concerned with how their ‘Personally Identifiable Information’ (PII) is being used online. PII, is information that can be used on its own or with other information to identify, contact, or locate a single person, or to identify an individual in context. Please read our privacy policy carefully to get a clear understanding of how we collect, use, protect or otherwise handle your Personally Identifiable Information in accordance with our website.</p>

        <p>
            <strong>Information Collected</strong> <br/>
            When ordering or registering on our site, as appropriate, you may be asked to enter your name, email address, mailing address, phone number, credit card information, customer product catalog information, Customer information relating to invoices, payments, packages and shipments or other details to help you with your experience.
            We collect information from you when you register on our site, place an order, subscribe to a newsletter, open a Support Ticket or enter information on our site. Provide us with feedback on our products or services.
        </p>

        <p>
            <strong>Use of Personal Information</strong> <br/>
            We may use the information we collect from you when you register, make a purchase, sign up for our newsletter, respond to a survey or marketing communication, surf the website, or use certain other site features in the following ways:
            <ul>
                <li>To personalize your experience and to allow us to deliver the type of content and product offerings in which you are most interested.</li>
                <li>To allow us to better service you in responding to your customer service requests.</li>
                <li>To quickly process your transactions.</li>
                <li>To follow up with them after correspondence (live chat, email or phone inquiries)</li>
            </ul>
        </p>

        <p>
            <strong>Network and Information Security</strong> <br/>
            Our website is scanned on a regular basis for security holes and known vulnerabilities in order to make your visit to our site as safe as possible.
            Your personal information is contained behind secured networks and is only accessible by a limited number of persons who have special access rights to such systems, and are required to keep the information confidential. In addition, all sensitive/credit information you supply is encrypted via Secure Socket Layer (SSL) technology.
            We implement a variety of security measures when a user places an order enters, submits, or accesses their information to maintain the safety of your personal information.
        </p>

        <p>
            <strong>Cookies</strong> <br/>
            Cookies are small files that a site or its service provider transfers to your computer’s hard drive through your Web browser (if you allow) that enables the site’s or service provider’s systems to recognize your browser and capture and remember certain information. For instance, we use cookies to help us remember and process the items in your shopping cart. They are also used to help us understand your preferences based on previous or current site activity, which enables us to provide you with improved services. We also use cookies to help us compile aggregate data about site traffic and site interaction so that we can offer better site experiences and tools in the future.
        </p>

        <p>
            <strong>We use cookies to:</strong> <br/>
            Understand and save user’s preferences for future visits.
            Compile aggregate data about site traffic and site interactions in order to offer better site experiences and tools in the future. We may also use trusted third-party services that track this information on our behalf.

            You can choose to have your computer warn you each time a cookie is being sent, or you can choose to turn off all cookies. You do this through your browser settings. Since browser is a little different, look at your browser’s Help Menu to learn the correct way to modify your cookies.

            If users disable cookies in their browser:
            If you turn cookies off, some features will be disabled. Some of the features that make your site experience more efficient and may not function properly. However, you will still be able to place orders, but may not be able to sign in and access certain Web page features or services.
        </p>

        <p>
            <strong>Third-Party Disclosure</strong> <br/>
            We do not sell, trade, or otherwise transfer to outside parties your Personally Identifiable Information unless we provide users with advance notice. This does not include website hosting partners and other parties who assist us in operating our website, conducting our business, or serving our users, so long as those parties agree to keep this information confidential. We may also release information when it’s release is appropriate to comply with the law, enforce our site policies, or protect ours or others’ rights, property or safety.
            However, non-personally identifiable visitor information may be provided to other parties for marketing, advertising, or other uses.
            
        </p>

        <p>
            Occasionally, at our discretion, we may include or offer third-party products or services on our website. These third-party sites have separate and independent privacy policies. We therefore have no responsibility or liability for the content and activities of these linked sites. Nonetheless, we seek to protect the integrity of our site and welcome any feedback about these sites.
            We use Google Analytics on our website. Google, as a third-party vendor, uses cookies to serve ads on our site. Google’s use of the DART cookie enables it to serve ads to our users based on previous visits to our site and other sites on the Internet. Users may opt-out of the use of the DART cookie by visiting the Google Ad and Content Network privacy policy.
            We, along with third-party vendors such as Google use first-party cookies (such as the Google Analytics cookies) and third-party cookies (such as the DoubleClick cookie) or other third-party identifiers together to compile data regarding user interactions with ad impressions and other ad service functions as they relate to our website.
        </p>

        <p>
            <strong>Accessing or Correcting Personal Information</strong> <br/>
            You can access all your private information that we collect online via the tool, admin and account pages of your account. You can correct factual errors in your private information by sending us a request that credibly shows error. To protect your privacy and security, we will also take reasonable steps to verify your identity before granting access or making corrections.
            
        </p>
        <p>
            <strong>Contacting Us</strong> <br/>
            If there are any questions regarding this privacy policy, you may contact us via email to:shopsbuben@gmail.com
        </p>  
      </div>
  </div>
</template>

<script>
import api from '../../src/api/moudles/shopaccess'
export default {
data(){
return{
    
}
},
created(){
  
},
methods:{
   
        
  

}
}

</script>
<style lang="scss" scoped>
.shopify_wrapper{


    p{
        font-size: 23px;
        word-spacing: normal;
        color: #85868c;
        margin-bottom: 20px;
    }
   


    .vbfkh{
            color: rgb(0, 199, 163);
            font-size: 20px;
            margin-right: 15px;
        }

    .center{
        margin: 0 auto;
        width: 1200px;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        min-height: 100vh;

        .success{
            font-size: 18px;
            background: #eee;
            padding: 3px 15px;
        }

        

        .vknf{
            display: flex;
            margin: 8px 0;
        }

        .vkjfmp{
            margin-right: 8px;
        }

        .desct{
            color: #409eff;
            margin: 5px 10px;
            font-size: 20px;
            cursor: pointer;
        }


    }
    

    .header_warpper{
        margin: 7px auto;
        height: 50px;
        display: flex;
        justify-content: space-between;
        align-items: center;
        width: 1200px;
        padding-bottom: 16px;
        border-bottom: 1px solid #606266;
       


        .left{
            display: flex;
            align-items: center;
            padding-top: 30px;
          

            .title{
                font-size: 25px;
                font-weight: bold;
                  color: #409eff;
            }

            .title::after{
                content:'|';
                color:#606266;
                padding:0 10px
            }

            .logo{
                width: 30px;
                height: 15px;
                
                background-size: 100%;
                background-repeat: no-repeat;;
                background-image: url('../assets/img/h5_login.png');
            }
        }


        .right{
            display: flex;
            
            align-items: center;

            .desxc{
                line-height: 75px;
                font-size: 20px;
                font-weight: bold;
                margin-left: 15px;
            }
        }


        .shopifylogo{
            width: 60px;
            height: 60px;
            background-image: url('https://erp.shopsbu.com/img/h5_login.c3c8501f.png');
            background-size: 100%;
            background-repeat: no-repeat;;
        }

    }
}
</style>